import React from 'react';

const BrandLink = ({ href, logo, name, alt }) => {
  return (
    <a href={href} className='brand-link'>
      <img src={logo} alt={alt} className='brand-image img-circle elevation-3' style={{ opacity: 0.8 }} />
      <span className='brand-text'>{name}</span>
    </a>
  );
};

export default BrandLink;
